// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton-module--base--5JRj_","active":"skeleton-module--active--1Wasv","skeleton":"skeleton-module--skeleton--YuSVn"};